'use client'

import { useMemo } from 'react'

import SsrContext, { type SsrContextProps } from '@/contexts/ssr'

interface SsrContextProviderProps extends SsrContextProps {
  children: React.ReactNode
}

export default function SsrContextProvider({
  children,
  requestUserAgent,
  selectedCurrency,
  countryCode,
  regionCode,
}: SsrContextProviderProps) {
  const ssrContextValue = useMemo<SsrContextProps>(
    () => ({
      requestUserAgent,
      selectedCurrency,
      countryCode,
      regionCode,
    }),
    [requestUserAgent, selectedCurrency],
  )
  return <SsrContext value={ssrContextValue}>{children}</SsrContext>
}
